import { gql } from '@apollo/client';

export const insertSelfOnboardingRequestMutation = gql`
  mutation ($object: self_onboarding_requests_insert_input!) {
    insert_self_onboarding_requests_one(object: $object) {
      id
    }
  }
`;
